//  * @package         src/components/Dashboard
//  * @author          Riddhi D Parekh
//  * @date            02nd October 2018
//  * @type            Center Settings Component File
//  * @description -   This file renders the html and functionality for center component when settings tab is choosed.
<template>
  <div class="col-md-6 p-0 col-xs-12 survey_colume_2">
    <div class="colume_2_build padding15">
      <div class="top_setting_bar">
        <a
          v-if="all.in_survey_type == 3"
          href="#"
          class="iconDisplayCustom"
          data-toggle="tooltip"
          data-placement="top"
          title="Both"
        >
          <i class="fa fa-globe"></i>
          <i class="fa fa-1x fa-mobile iconClassBtn"></i>
        </a>
        <a
          v-else
          href="#"
          data-toggle="tooltip"
          data-placement="top"
          :title="all.in_survey_type == 1 ? 'Online Form' : 'Mobile Form'"
        >
          <i :class="all.in_survey_type == 1 ? 'fa fa-globe' :'fa fa-mobile icon-mobile-fn-size'" aria-hidden="true"></i>
        </a>
        <a
          href="#"
          data-toggle="tooltip"
          data-placement="top"
          :title="all.in_question_flow == 0 ? 'One At A Time' : 'All In One'"
        >
          <i
            :class="all.in_question_flow == 0 ? 'fa fa-long-arrow-down' : 'fa fa-sort-alpha-asc'"
            aria-hidden="true"
          ></i>
        </a>
        
        <a
          v-if="all.in_audit"
          href="#"
          data-toggle="tooltip"
          data-placement="top"
          title="audit form"
        >
          <img src="../../assets/images/edit-icon-1.png" alt="edit-icon" class="img-responsive">
        </a>
        
        <a
          v-if="all.in_loop_survey"
          href="#"
          data-toggle="tooltip"
          data-placement="top"
          title="loop form"
        >
          <i class="fa fa-repeat" aria-hidden="true"></i>
        </a>
      </div>

      <div class="build_survey">
        <h3>Setting</h3>
        <p>Build your own,individual surveys by drag and drop elements from left</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "centersetting",
  data() {
    return {};
  },
  computed: {
    // for icons above start screen
    ...mapGetters("LeftSidebarCreate", ["all", "surveytypes"])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/centersetting.vue